import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { UserState } from "../../api/models";
import { SubscriptionService } from "../../api/services";
import { GlobalApp } from "../../tools/global";
@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: [
    "./home.component.css"
  ]
})
export class HomeComponent implements OnInit, OnDestroy {

  userState: UserState = {
    reportOnly: false,
    userManagerOnly: false,
    invoiceManagerOnly: false,
    interactives: [],
    modifiedInteractives: [],
    xmlas: [],
    reportExportState: {},
    isInteractiveUser: false,
    isReportExportUser: false,
    isEmbeddedUser: false,
    hasAiChats: false,
    isValidState: false
  };

  userStateSubscription: Subscription = null;

  hasMultiple: boolean = false;
  selectedSection: number = 0;

  constructor(
    public app: GlobalApp,
    public subscriptionService: SubscriptionService
  ) {
    this.app.getAuthorizationStatus().subscribe((result) => {
      if (!result.isValid) {
        this.app.logOut();
      } else {
        this.app.refreshUserState(this.subscriptionService);
      }
    });
  }

  ngOnInit() {
    this.userStateSubscription = this.app.userState.subscribe((userState) => {
      this.userState = userState;
      if (
        (userState.isInteractiveUser && userState.isReportExportUser) ||
        (userState.isInteractiveUser && userState.isEmbeddedUser) ||
        (userState.isReportExportUser && userState.isEmbeddedUser)) {
        this.hasMultiple = true;
        }
    });
  }

  ngOnDestroy() {
    this.userStateSubscription.unsubscribe();
  }
}
